import { render, staticRenderFns } from "./unauthorized.vue?vue&type=template&id=4cbfe3b3&"
import script from "./unauthorized.vue?vue&type=script&lang=ts&"
export * from "./unauthorized.vue?vue&type=script&lang=ts&"
import style0 from "./unauthorized.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports